/* 趙雲傳・第 3 章：截江（211–212 年）
 * 長江由西往東流。北岸是公安（劉備在荊州的治所）與碼頭（碼頭前一片淺灘，船從這裡靠岸）；孫夫人的船從碼頭東邊出發，順流往東回吳。 */
export const DOCK = [1300, 1560], GONGAN = [1300, 1250], FLAG0 = [2300, 2450], EXIT_X = 8500, ZY0 = [900, 2250], ZF = [6300, 1900];
export default {
  id: 'zhaoyun_jiang', name: '江上', W: 9000, H: 5000, seed: 2112,
  bases: [GONGAN, [8400, 1000]],
  rivers: [{ pts: [[-100, 2600], [3000, 2520], [6000, 2650], [9100, 2560]], hw: 820, fords: [] }],
  roads: [{ pts: [[200, 1250], GONGAN, [4000, 1150], [8800, 1050]], w: 140 }, { pts: [GONGAN, [DOCK[0], DOCK[1] - 60]], w: 110 }],
  rocks: [[3200, 900, 420, 200], [6400, 800, 420, 200], [2500, 4400, 420, 200], [6800, 4300, 420, 200]],
  woods: 0.5,
  sight: 0.9,
  clearings: [[GONGAN[0], GONGAN[1], 520], [DOCK[0], DOCK[1] - 120, 480]],
  marsh: [[DOCK[0], DOCK[1] + 150, 320, 110]], // 碼頭前的淺灘：船可以划進來、人可以走，在這裡靠岸
  tents: [{ x: GONGAN[0], y: GONGAN[1], n: 5, r: 320, chief: true, col: '#3e7b50', flag: '劉' }],
};
